import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  wrapper: {
    width: '560px',
    minHeight: '250px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    marginTop: '24px',
  },
  rowWithColumn: {
    gap: '8px',
  },
  column: {
    flex: '1 1 50%',
  },
  formFieldContainer: {
    gap: '8px',
    minHeight: theme => theme.spacing(4),
  },
  poContainer: {
    width: '145px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: '48px',
  },
  alertText: {
    color: COLORS.red100,
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
});

export default styles;
